/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Scroll_DrivenInputs */

const en_svchip_scroll_driven = /** @type {(inputs: Svchip_Scroll_DrivenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scroll-driven`)
};

const ar_svchip_scroll_driven = /** @type {(inputs: Svchip_Scroll_DrivenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محرك بالتمرير`)
};

const bn_svchip_scroll_driven = /** @type {(inputs: Svchip_Scroll_DrivenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্ক্রল-ড্রিভেন`)
};

const de_svchip_scroll_driven = /** @type {(inputs: Svchip_Scroll_DrivenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrollgesteuert`)
};

const es_svchip_scroll_driven = /** @type {(inputs: Svchip_Scroll_DrivenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlado por desplazamiento`)
};

const fr_svchip_scroll_driven = /** @type {(inputs: Svchip_Scroll_DrivenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piloté par défilement`)
};

const pt_svchip_scroll_driven = /** @type {(inputs: Svchip_Scroll_DrivenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orientado por rolagem`)
};

const zh_svchip_scroll_driven = /** @type {(inputs: Svchip_Scroll_DrivenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`滚动驱动`)
};

const tr_svchip_scroll_driven = /** @type {(inputs: Svchip_Scroll_DrivenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaydırma odaklı`)
};

const ru_svchip_scroll_driven = /** @type {(inputs: Svchip_Scroll_DrivenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управляемый прокруткой`)
};

const pl_svchip_scroll_driven = /** @type {(inputs: Svchip_Scroll_DrivenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sterowanie przewijaniem`)
};

/**
* | output |
* | --- |
* | "Scroll-driven" |
*
* @param {Svchip_Scroll_DrivenInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_scroll_driven = /** @type {((inputs?: Svchip_Scroll_DrivenInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Scroll_DrivenInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_scroll_driven(inputs)
	if (locale === "bn") return bn_svchip_scroll_driven(inputs)
	if (locale === "de") return de_svchip_scroll_driven(inputs)
	if (locale === "es") return es_svchip_scroll_driven(inputs)
	if (locale === "fr") return fr_svchip_scroll_driven(inputs)
	if (locale === "pt") return pt_svchip_scroll_driven(inputs)
	if (locale === "zh") return zh_svchip_scroll_driven(inputs)
	if (locale === "tr") return tr_svchip_scroll_driven(inputs)
	if (locale === "ru") return ru_svchip_scroll_driven(inputs)
	if (locale === "pl") return pl_svchip_scroll_driven(inputs)
	return en_svchip_scroll_driven(inputs)
});